<app-modal-window [title]="'Создание коммерческих помещений'"
                  [visible]="true"
                  [width]="825"
                  [height]="638"
                  [scrollbar]="true"
                  (close)="dialogRef.close()">

  <div class="loading" *ngIf="loading; else loaded"></div>
  <ng-template #loaded>
    <form class="container" [formGroup]="form" (ngSubmit)="save()">
      <div class="container-body">
        <div class="form-control">
          <label>
            Тип нежилого помещения <span class="required">*</span>
          </label>
          <div class="input-container">
            <select formControlName="roomTypeItemID" class="select" (change)="changeRoomType($event)">
              <option value="null" disabled selected>Выберите</option>
              @for (room of roomTypes; track room) {
                <option [value]="room.id">{{ room.title }}</option>
              }
            </select>
          </div>
        </div>
        <div class="form-control">
          <label>
            Номер подъезда <span class="required">*</span>
          </label>
          <div class="input-container">
            <input type="text" formControlName="entrance" class="input">
          </div>
        </div>
        <div class="form-control">
          <label>
            Номер помещения <span class="required">*</span>
          </label>
          <div class="input-container">
            <input type="text" formControlName="placeNumber" class="input" [mask]="'separator'">
          </div>

        </div>
        <div class="form-control">
          <label>
            Общая площадь <span class="required">*</span>
          </label>
          <div class="input-container">
            <input type="text" formControlName="area" class="input" [mask]="'separator.2'">
            кв.м.
          </div>
        </div>
      </div>
      <div class="container-footer">
        <button class="btn" *ngIf="loadingSave; else loadedSave">
          <span class="loading"></span>
        </button>
        <ng-template #loadedSave>
          <button class="btn btn-apply" type="submit">Сохранить</button>
        </ng-template>
        <button class="btn btn-cancel" type="button" matDialogClose>Закрыть</button>
      </div>
    </form>
  </ng-template>

</app-modal-window>
